const rateOffPeak = () => {
  return {
    name: 'Rate VTOU',
    title: 'Residential Service (Experimental)',
    rateElements: [
      // Fixed Monthly Charge
      {
        rateElementType: 'FixedPerMonth',
        name: 'Basic Customer Charge',
        rateComponents: [
          {
            charge: 20.44,
            name: 'Basic Customer Charge',
          },
        ],
      },
      // Energy Charges for Distribution kWh
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Summer',
        rateComponents: [
          {
            charge: 0.09604, // 9.604¢ per kWh
            months: [5, 6, 7], // June - Aug
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [7, 8, 9, 10, 11, 12, 13, 14, 18, 19, 20, 21, 22, 23], //  07:00-14:00, 18:00-23:00
            name: 'Summer On-Peak kWh Charge',
          },
          {
            charge: 0.01609, // 1.609¢ per kWh
            months: [5, 6, 7], // June - Aug
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [0, 1, 2, 3, 4, 5, 6], // 00:00-06:00
            name: 'Summer Off-Peak kWh Charge',
          },
          {
            charge: 0.01609, // 1.609¢ per kWh
            months: [5, 6, 7], // June - Aug
            daysOfWeek: [0, 6], // Sun, Sat
            hourStarts: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23,
            ], // All Hours
            name: 'Summer Weekend Off-Peak kWh Charge',
          },
          {
            charge: 0.18022, // 18.022¢ per kWh
            months: [5, 6, 7], // June - Aug
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [15, 16, 17], // 15:00-17:00
            name: 'Summer Super Peak kWh Charge',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Winter',
        rateComponents: [
          {
            charge: 0.083646, // 8.3646¢ per kWh
            months: [0, 1, 2, 3, 4, 8, 9, 10, 11], // Jan - May, Sept - Dec
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [
              7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
            ], //  07:00-23:00
            name: 'Winter On-Peak kWh Charge',
          },
          {
            charge: 0.01609, // 1.609¢ per kWh
            months: [0, 1, 2, 3, 4, 8, 9, 10, 11], // Jan - May, Sept - Dec
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [0, 1, 2, 3, 4, 5, 6], // 00:00-06:00
            name: 'Winter Off-Peak kWh Charge',
          },
          {
            charge: 0.01609, // 1.609¢ per kWh
            months: [0, 1, 2, 3, 4, 8, 9, 10, 11], // Jan - May, Sept - Dec
            daysOfWeek: [0, 6], // Sun, Sat
            hourStarts: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23,
            ], // All Hours
            name: 'Winter Weekend Off-Peak kWh Charge',
          },
        ],
      },
    ],
  };
};

export default rateOffPeak;
